/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_StyleInputs */

const cs_property_ai_style = /** @type {(inputs: Property_Ai_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Styl stagingu`)
};

const en_property_ai_style = /** @type {(inputs: Property_Ai_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staging style`)
};

/**
* | output |
* | --- |
* | "Staging style" |
*
* @param {Property_Ai_StyleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_style = /** @type {((inputs?: Property_Ai_StyleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_StyleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_style(inputs)
	return cs_property_ai_style(inputs)
});